// utils/cookies.ts

export function getCookie(name: string): string | undefined {
    if (typeof document === 'undefined') return undefined; // ✅ Prevent SSR crash
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
}

export function setCookie(name: string, value: string, maxAge: number) {
    if (typeof document === 'undefined') return; // ✅ Only run in browser
    document.cookie = `${name}=${value}; path=/; max-age=${maxAge}`;
}

export function deleteCookie(name: string) {
    if (typeof document === 'undefined') return; // ✅ Only run in browser
    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}
